import React from 'react';


const FMReadingCard = ({ data, itemParent, isLayoutRow, sectionLength, onCardAction = (() => { }) }) => {
    if (!data || data.length === 0) return null;
    
    return (
        <div className={ isLayoutRow && data.length === 2 ? "flex justify-center" : "w-full"}>
            <div
                className={isLayoutRow && data.length === 1
                    ? `` :
                    isLayoutRow && data.length === 2
                        ? `grid grid-cols-1 gap-3 w-[188px]` :
                        isLayoutRow && sectionLength >= 2
                            ? `grid grid-cols-2 gap-x-2 gap-y-2 lg:px-0 xl:px-3`
                            : `flex gap-8 items-center justify-center px-8`}
            >
                {data.map((item, index) => (
                    <div
                        key={index}
                        className={isLayoutRow && data.length === 1 ? "w-[188px] mx-auto" : ""}
                        style={{ cursor: "pointer" }}
                        onClick={() => onCardAction(item, itemParent)}
                    >
                        <p dangerouslySetInnerHTML={{ __html: item?.content }} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default React.memo(FMReadingCard);